//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[[0,"OutputPortName",1,0]],[],[]];
SPLM.Motion.ControlOperationBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ControlOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ControlOperationBuilder.AmplifierGainType = Object.freeze({
    "Expression" : "Expression", "Function" : "Function", "Profile2D" : "Profile2D", "CustomizedSolver" : "CustomizedSolver"});

SPLM.Motion.ControlOperationBuilder.AmplifierGainYValuePurpose = Object.freeze({
    "AsGain" : "AsGain", "AsOutput" : "AsOutput", "DerivativeAsOutput" : "DerivativeAsOutput"});

SPLM.Motion.ControlOperationBuilder.ControlFunctionType = Object.freeze({
    "Abs" : "Abs", "Acos" : "Acos", "Acosh" : "Acosh", "Asin" : "Asin", "Asinh" : "Asinh", "Atan" : "Atan", "Atanh" : "Atanh", "Cos" : "Cos", "Cosh" : "Cosh", "Exp" : "Exp", "Fderiv" : "Fderiv", "Haversine" : "Haversine", "Ln" : "Ln", "Log" : "Log", "Max" : "Max", "Min" : "Min", "Npower" : "Npower", "Nroot" : "Nroot", "Polynomial" : "Polynomial", "Sderiv" : "Sderiv", "Sin" : "Sin", "Sinh" : "Sinh", "Sqrt" : "Sqrt", "Step" : "Step", "Step5" : "Step5", "Tan" : "Tan", "Tanh" : "Tanh"});

SPLM.Motion.ControlOperationBuilder.SwitchSignalType = Object.freeze({
    "Digital" : "Digital", "Analog" : "Analog"});

SPLM.Motion.ControlOperationBuilder.SteadyStateDriverType = Object.freeze({
    "Rotation" : "Rotation", "Translation" : "Translation"});

export default SPLM;